import React from 'react';
import { Route, Redirect } from 'react-router-dom';

import { useAuthState } from "react-firebase-hooks/auth";

import { firebaseAuth } from './firebase/init-firebase';

import FullScreenLoader from './components/loaders/fullscreen-loader';

const SignUp = React.lazy(() => import('./pages/authentication/sign-up'));
const SignIn = React.lazy(() => import('./pages/authentication/sign-in'));

export const publicRoutesList = [
    { path: '/auth/sign-up', exact: true, name: 'SignUp', component: SignUp },
    { path: '/auth/sign-in', exact: true, name: 'SignIn', component: SignIn }
];

const PublicRoute = ({ component: Component, ...rest }) => {

    const [user, loading, error] = useAuthState(firebaseAuth);

    if (loading) return <FullScreenLoader />

    return (
        <Route
            {...rest}
            render={(routeProps) => {
                return !user
                ? <Component {...routeProps} />
                : <Redirect to="/" />
            }}
        />
    )
}
export default PublicRoute;